<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryTeacheInfo">
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.instructor"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md1>
      <v-btn round :disabled="btn_state" v-on:click="queryTeacheInfo()">
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabTeach.json";

export default {
  data: () => ({
    labels: {
      course_title: "",
      instructor: "",
      search: "",
    },
    course_name: "",
    course_teacher: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    queryTeacheInfo: function () {
      var query_params = {
        Semester: this.$store.state.select_semester,
        CourseNo: "EP",
        CourseName: this.course_name,
        CourseTeacher: this.course_teacher,
        Dimension: "",
        CourseNotes: "",
        ForeignLanguage: 0,
        OnlyGeneral: 0,
        OnleyNTUST: 0,
        OnlyMaster: 0,
        Language: this.select_language.lang,
      };
      this.$store.dispatch("queryCourseInfo", query_params);
    },
    setLanguage: function (select_language) {
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
    },
  },
};
</script>
